import config from 'react-global-configuration';
import Immutable from 'immutable';

export const POPUPS_LOADED = 'POPUPS_LOADED';
export const popupsLoaded = (popups) => {
  return {
    type: POPUPS_LOADED,
    payload: popups,
  };
};

export const POPUPS_LOAD = 'POPUPS_LOAD';
export const popupsLoad = () => {
  return (dispatch, getState) => {
    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;
    fetch(`${PATH}/api/popup-announcements?_format=json`)
      .then((response) => response.json())
      .then((json) => {
        return Immutable.fromJS(json);
      })
      .then((response) => {
        dispatch(popupsLoaded(response));
      })
      .catch((error) => {
        console.error(error);
      });
  };
};
